// src/platform/use-back-handler.ts
// React hook to register a back handler when an overlay is open.

import { useEffect } from 'react';
import { pushBackHandler, removeBackHandler } from './back-handler';
import { isNative } from './platform';

/**
 * Register a back button handler while `active` is true.
 * When the Android back button is pressed, `onBack` is called (should close the overlay).
 * Handlers are stacked — the most recently registered active handler wins.
 *
 * @param id Unique key for this overlay (e.g. 'sidebar', 'settings', 'notes')
 * @param active Whether the overlay is currently open
 * @param onBack Callback to close the overlay
 */
export function useBackHandler(id: string, active: boolean, onBack: () => void): void {
  useEffect(() => {
    if (!isNative() || !active) {
      removeBackHandler(id);
      return;
    }
    const cleanup = pushBackHandler(id, onBack);
    return cleanup;
  }, [id, active, onBack]);
}
